import { render, staticRenderFns } from "./ShopStar.vue?vue&type=template&id=35b82828&scoped=true"
import script from "./ShopStar.vue?vue&type=script&lang=js"
export * from "./ShopStar.vue?vue&type=script&lang=js"
import style0 from "./ShopStar.vue?vue&type=style&index=0&id=35b82828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b82828",
  null
  
)

export default component.exports